// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  global css which apply to Desktop, Web and Extension
  copy from:
    node_modules/@expo/webpack-config/web-default/index.html
 */

/* ---------------------------------------------- */

/**
 * Extend the react-native-web reset:
 * https://github.com/necolas/react-native-web/blob/master/packages/react-native-web/src/exports/StyleSheet/initialRules.js
 */
html,
body,
#root {
  width: 100%;
  /* To smooth any scrolling behavior */
  -webkit-overflow-scrolling: touch;
  margin: 0px;
  padding: 0px;
  /* Allows content to fill the viewport and go beyond the bottom */
  height: 100%;
  overflow: hidden;
}

#root {
  flex-shrink: 0;
  flex-basis: auto;
  flex-grow: 1;
  display: flex;
  flex: 1;
}

html {
  scroll-behavior: smooth;
  /* Prevent text size change on orientation change https://gist.github.com/tfausak/2222823#file-ios-8-web-app-html-L138 */
  -webkit-text-size-adjust: 100%;
  height: calc(100% + env(safe-area-inset-top));
}

body {
  display: flex;
  /* Allows you to scroll below the viewport; default value is visible */
  overflow-y: auto;
  overscroll-behavior-y: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -ms-overflow-style: scrollbar;
}

/* Enable for apps that support dark-theme */
/*@media (prefers-color-scheme: dark) {
  body {
    background-color: black;
  }
}*/

/*
  hide Scrollbar
  in JS: extendTheme()
*/
/* set width=0 to hide scrollbar */
::-webkit-scrollbar {
  /* width: 0 controls vertical scrollbar, height: 0 controls horizontal scrollbar */
  width: 0;
  height: 0;
  background: transparent;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  /* gray color palette comes from design file "illustration" */
  background: #74748b;
  border-radius: 3px;
}

input {
  outline: none;
  min-width: 0;
}

[role='button'] {
  outline: none;
}

button,
input,
[role='button'],
/* \`Select\` and \`Toggle\` are typically wrapped by a \`Group\`, so we handle them consistently. */
.is_GroupFrame {
  -webkit-app-region: no-drag;
}

textarea {
  outline: none;
  min-width: 0;
}

/* data-testid="Segment_Button" */
[data-testid='Segment_Button'] {
  width: 100%;
}

/* WallectConnect Modal */
.walletconnect-modal__base {
  max-width: 400px !important;
}

.debug-render-tracker-times-badge {
  position: absolute;

  /* left: 50%; */
  /* transform: translateX(-50%); */
  z-index: 999999;
  font-size: 12px;
  color: #a17b83;
  font-weight: bold;
}
.debug-render-tracker-times-badge.top-right {
  top: 0;
  right: 2px;
}
.debug-render-tracker-times-badge.top-left {
  top: 0;
  left: 2px;
}

.debug-render-tracker-animated-bg {
  position: relative;
}

.debug-render-tracker-animated-bg:before {
  pointer-events: none;
  content: '';
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: debugRenderTrackerColorFade 1s forwards;
}

@keyframes debugRenderTrackerColorFade {
  from {
    background-color: #e2c6c4;
  }
  to {
    background-color: transparent;
  }
}

.debug-render-tracker-animated-bg0 {
  position: relative;
}

.debug-render-tracker-animated-bg0:before {
  pointer-events: none;
  content: '';
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: debugRenderTrackerColorFade0 1s forwards;
}

@keyframes debugRenderTrackerColorFade0 {
  from {
    background-color: #aab8ab;
  }
  to {
    background-color: transparent;
  }
}

/* custom sonner toast styles, should remove if the burnt library support such api to custom styles */
[data-sonner-toast] {
  max-width: calc(100vw - 32px);
}

.app-region-no-drag {
  -webkit-app-region: no-drag;
}

/* react-beautiful-dnd */
[data-rbd-drag-handle-context-id] {
  cursor: default !important;
}

.onekey-img-cropper {
  height: 100%;
}

body > div.cet-container {
  z-index: unset;
}

/* 
  Add break-all class to handle word breaking in web platform,
  since react-native doesn't support wordBreak property directly.
  Used by TextAreaInput component for text wrapping.
*/
.break-all {
  word-break: break-all;
}

/* Hide title bar icon on Windows/Linux Desktop */
.onekey-body >.cet-titlebar >.cet-icon {
  display: none;
}

.onekey-body >.cet-titlebar >.cet-menubar {
  margin-left: 16px;
}

.normal-scrollbar::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.normal-scrollbar::-webkit-scrollbar-track {
  background: #F9F9F9;
  border-radius: 100px;
}

.normal-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.27);
  border-radius: 100px;
}

w3m-modal { 
  z-index: 99993173;
}`, "",{"version":3,"sources":["webpack://./../../packages/shared/src/web/index.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,mDAAmD;;AAEnD;;;EAGE;AACF;;;EAGE,WAAW;EACX,qCAAqC;EACrC,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,iEAAiE;EACjE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,wHAAwH;EACxH,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;;;;EAIE;;AAEF;;;CAGC;AACD,kCAAkC;AAClC;EACE,kFAAkF;EAClF,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;;EAElB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,UAAU;AACZ;AACA;EACE,MAAM;EACN,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,qGAAqG;AACrG;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;CAIC;AACD;EACE,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/*\n  global css which apply to Desktop, Web and Extension\n  copy from:\n    node_modules/@expo/webpack-config/web-default/index.html\n */\n\n/* ---------------------------------------------- */\n\n/**\n * Extend the react-native-web reset:\n * https://github.com/necolas/react-native-web/blob/master/packages/react-native-web/src/exports/StyleSheet/initialRules.js\n */\nhtml,\nbody,\n#root {\n  width: 100%;\n  /* To smooth any scrolling behavior */\n  -webkit-overflow-scrolling: touch;\n  margin: 0px;\n  padding: 0px;\n  /* Allows content to fill the viewport and go beyond the bottom */\n  height: 100%;\n  overflow: hidden;\n}\n\n#root {\n  flex-shrink: 0;\n  flex-basis: auto;\n  flex-grow: 1;\n  display: flex;\n  flex: 1;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  /* Prevent text size change on orientation change https://gist.github.com/tfausak/2222823#file-ios-8-web-app-html-L138 */\n  -webkit-text-size-adjust: 100%;\n  height: calc(100% + env(safe-area-inset-top));\n}\n\nbody {\n  display: flex;\n  /* Allows you to scroll below the viewport; default value is visible */\n  overflow-y: auto;\n  overscroll-behavior-y: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -ms-overflow-style: scrollbar;\n}\n\n/* Enable for apps that support dark-theme */\n/*@media (prefers-color-scheme: dark) {\n  body {\n    background-color: black;\n  }\n}*/\n\n/*\n  hide Scrollbar\n  in JS: extendTheme()\n*/\n/* set width=0 to hide scrollbar */\n::-webkit-scrollbar {\n  /* width: 0 controls vertical scrollbar, height: 0 controls horizontal scrollbar */\n  width: 0;\n  height: 0;\n  background: transparent;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  /* gray color palette comes from design file \"illustration\" */\n  background: #74748b;\n  border-radius: 3px;\n}\n\ninput {\n  outline: none;\n  min-width: 0;\n}\n\n[role='button'] {\n  outline: none;\n}\n\nbutton,\ninput,\n[role='button'],\n/* `Select` and `Toggle` are typically wrapped by a `Group`, so we handle them consistently. */\n.is_GroupFrame {\n  -webkit-app-region: no-drag;\n}\n\ntextarea {\n  outline: none;\n  min-width: 0;\n}\n\n/* data-testid=\"Segment_Button\" */\n[data-testid='Segment_Button'] {\n  width: 100%;\n}\n\n/* WallectConnect Modal */\n.walletconnect-modal__base {\n  max-width: 400px !important;\n}\n\n.debug-render-tracker-times-badge {\n  position: absolute;\n\n  /* left: 50%; */\n  /* transform: translateX(-50%); */\n  z-index: 999999;\n  font-size: 12px;\n  color: #a17b83;\n  font-weight: bold;\n}\n.debug-render-tracker-times-badge.top-right {\n  top: 0;\n  right: 2px;\n}\n.debug-render-tracker-times-badge.top-left {\n  top: 0;\n  left: 2px;\n}\n\n.debug-render-tracker-animated-bg {\n  position: relative;\n}\n\n.debug-render-tracker-animated-bg:before {\n  pointer-events: none;\n  content: '';\n  position: absolute;\n  z-index: 999999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  animation: debugRenderTrackerColorFade 1s forwards;\n}\n\n@keyframes debugRenderTrackerColorFade {\n  from {\n    background-color: #e2c6c4;\n  }\n  to {\n    background-color: transparent;\n  }\n}\n\n.debug-render-tracker-animated-bg0 {\n  position: relative;\n}\n\n.debug-render-tracker-animated-bg0:before {\n  pointer-events: none;\n  content: '';\n  position: absolute;\n  z-index: 999999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  animation: debugRenderTrackerColorFade0 1s forwards;\n}\n\n@keyframes debugRenderTrackerColorFade0 {\n  from {\n    background-color: #aab8ab;\n  }\n  to {\n    background-color: transparent;\n  }\n}\n\n/* custom sonner toast styles, should remove if the burnt library support such api to custom styles */\n[data-sonner-toast] {\n  max-width: calc(100vw - 32px);\n}\n\n.app-region-no-drag {\n  -webkit-app-region: no-drag;\n}\n\n/* react-beautiful-dnd */\n[data-rbd-drag-handle-context-id] {\n  cursor: default !important;\n}\n\n.onekey-img-cropper {\n  height: 100%;\n}\n\nbody > div.cet-container {\n  z-index: unset;\n}\n\n/* \n  Add break-all class to handle word breaking in web platform,\n  since react-native doesn't support wordBreak property directly.\n  Used by TextAreaInput component for text wrapping.\n*/\n.break-all {\n  word-break: break-all;\n}\n\n/* Hide title bar icon on Windows/Linux Desktop */\n.onekey-body >.cet-titlebar >.cet-icon {\n  display: none;\n}\n\n.onekey-body >.cet-titlebar >.cet-menubar {\n  margin-left: 16px;\n}\n\n.normal-scrollbar::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n.normal-scrollbar::-webkit-scrollbar-track {\n  background: #F9F9F9;\n  border-radius: 100px;\n}\n\n.normal-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.27);\n  border-radius: 100px;\n}\n\nw3m-modal { \n  z-index: 99993173;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
